import {
  HTTP_UPDATEBUHEAD_FETCHING,
  HTTP_UPDATEBUHEAD_SUCCESS,
  HTTP_UPDATEBUHEAD_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_UPDATEBUHEAD_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_UPDATEBUHEAD_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_UPDATEBUHEAD_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
